import React, { useState } from "react";
import Facebook from "../../assets/facebook.png";
import Instagram from "../../assets/instagram.png";
import Youtube from "../../assets/youtube.png";
import LinkedIn from "../../assets/linkedin.png";
import call from "../../assets/call.png";
import { getApiData } from "../../services/index";
import GetInTouch from "../Home/GetInTouch/GetInTouch";

const countries = [
  "United States",
  "Canada",
  "United Kingdom",
  "Australia",
  "Germany",
  "France",
  "Japan",
  "India",
  "Brazil",
  "China",
];

const ContactUs = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    country: "",
    city: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    // First Name validation
    if (!formData.firstName.trim()) {
      newErrors.firstName = "First name is required";
    }

    // Last Name validation
    if (!formData.lastName.trim()) {
      newErrors.lastName = "Last name is required";
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }

    // Mobile validation (basic - just checks if it's not empty and contains only numbers)
    const mobileRegex = /^[0-9+\-\s()]+$/;
    if (!formData.mobile.trim()) {
      newErrors.mobile = "Mobile number is required";
    } else if (!mobileRegex.test(formData.mobile)) {
      newErrors.mobile = "Invalid mobile number";
    }

    // Country validation
    if (!formData.country) {
      newErrors.country = "Country is required";
    }

    // City validation
    if (!formData.city.trim()) {
      newErrors.city = "City is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      const { firstName, lastName, email, mobile, country, city } = formData;
      const app = {
        firstName,
        lastName,
        email,
        mobile,
        country,
        city,
      };
      console.log("handleSubmit: ", app);

      getApiData("api/submit_enquiry", app).then((result) => {
        let responseJson = result;
        console.log("result: ", result);
        if (responseJson && result["status"] === 200) {
          alert("Form submitted");

          // Clear the form fields after successful submission
          setFormData({
            firstName: "",
            lastName: "",
            email: "",
            mobile: "",
            country: "",
            city: "",
          });
        } else {
          alert("Form not submitted");
        }
      });
    } else {
      console.log("Form has errors");
    }
  };

  return (
    <>
      <div class="section for-contact">
        <div class="container">
          <div class="w-layout-grid contact-grid-main">
            <div id="w-node-_28f8e666-bebf-7af6-ed46-f0415ce3f37d-4b337bb9">
              <div>
                <h3 class="small-title">
                  Get in touch with our team for expert assistance and to
                  explore our comprehensive range of services.
                </h3>
              </div>
              <div class="margin-30px">
                <div>
                  <div className=" mx-auto p-6 bg-white rounded-lg shadow-md">
                    <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">
                      Get In Touch
                    </h2>
                    <form onSubmit={handleSubmit} className="space-y-4">
                      {/* First Name */}
                      <div>
                        <label
                          htmlFor="firstName"
                          className="block text-sm font-medium text-gray-700"
                        >
                          First Name
                        </label>
                        <input
                          type="text"
                          id="firstName"
                          name="firstName"
                          value={formData.firstName}
                          onChange={handleChange}
                          className={`mt-1 block w-full rounded-md border ${
                            errors.firstName
                              ? "border-red-500"
                              : "border-gray-300"
                          } shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 min-h-9 pl-2`}
                        />
                        {errors.firstName && (
                          <p className="mt-1 text-sm text-red-500 ">
                            {errors.firstName}
                          </p>
                        )}
                      </div>

                      {/* Last Name */}
                      <div>
                        <label
                          htmlFor="lastName"
                          className="block text-sm font-medium text-gray-700"
                        >
                          Last Name
                        </label>
                        <input
                          type="text"
                          id="lastName"
                          name="lastName"
                          value={formData.lastName}
                          onChange={handleChange}
                          className={`mt-1 block w-full rounded-md border ${
                            errors.lastName
                              ? "border-red-500"
                              : "border-gray-300"
                          } shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 min-h-9 pl-2`}
                        />
                        {errors.lastName && (
                          <p className="mt-1 text-sm text-red-500">
                            {errors.lastName}
                          </p>
                        )}
                      </div>

                      {/* Email */}
                      <div>
                        <label
                          htmlFor="email"
                          className="block text-sm font-medium text-gray-700"
                        >
                          Email
                        </label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          className={`mt-1 block w-full rounded-md border ${
                            errors.email ? "border-red-500" : "border-gray-300"
                          } shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 min-h-9 pl-2`}
                        />
                        {errors.email && (
                          <p className="mt-1 text-sm text-red-500">
                            {errors.email}
                          </p>
                        )}
                      </div>

                      {/* Mobile */}
                      <div>
                        <label
                          htmlFor="mobile"
                          className="block text-sm font-medium text-gray-700"
                        >
                          Mobile Number
                        </label>
                        <input
                          type="tel"
                          id="mobile"
                          name="mobile"
                          value={formData.mobile}
                          onChange={handleChange}
                          className={`mt-1 block w-full rounded-md border ${
                            errors.mobile ? "border-red-500" : "border-gray-300"
                          } shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 min-h-9 pl-2`}
                        />
                        {errors.mobile && (
                          <p className="mt-1 text-sm text-red-500">
                            {errors.mobile}
                          </p>
                        )}
                      </div>

                      {/* Country Dropdown */}
                      <div>
                        <label
                          htmlFor="country"
                          className="block text-sm font-medium text-gray-700"
                        >
                          Country
                        </label>
                        <select
                          id="country"
                          name="country"
                          value={formData.country}
                          onChange={handleChange}
                          className={`mt-1 block w-full rounded-md border ${
                            errors.country
                              ? "border-red-500"
                              : "border-gray-300"
                          } shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 min-h-9 pl-2`}
                        >
                          <option value="">Select a Country</option>
                          {countries.map((country, index) => (
                            <option key={index} value={country}>
                              {country}
                            </option>
                          ))}
                        </select>
                        {errors.country && (
                          <p className="mt-1 text-sm text-red-500">
                            {errors.country}
                          </p>
                        )}
                      </div>

                      {/* City */}
                      <div>
                        <label
                          htmlFor="city"
                          className="block text-sm font-medium text-gray-700"
                        >
                          City
                        </label>
                        <input
                          type="text"
                          id="city"
                          name="city"
                          value={formData.city}
                          onChange={handleChange}
                          className={`mt-1 block w-full rounded-md border ${
                            errors.city ? "border-red-500" : "border-gray-300"
                          } shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 min-h-9 pl-2`}
                        />
                        {errors.city && (
                          <p className="mt-1 text-sm text-red-500">
                            {errors.city}
                          </p>
                        )}
                      </div>

                      {/* Submit Button */}
                      <div>
                        <button
                          type="submit"
                          className="w-full bg-[#1D2E63] text-white py-2 px-4 rounded-md hover:bg-[#444444] focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div class="contact-form-right-side">
              <div>
                <h3 class="small-title _20px">Send us a message.</h3>
                <div class="margin-30px">
                  <div class="contact-details-flex">
                    <div class="contact-details">
                      <p class="label dark">
                        Email<span class="gray-text-color"></span>
                      </p>
                      <div>
                        <a
                          href="mailto:contact@winmigrationgroup.com"
                          class="contact-link"
                        >
                          contact@winmigrationgroup.com
                        </a>
                      </div>
                    </div>
                    <div>
                      <p class="label dark">
                        Phone<span class="gray-text-color"></span>
                      </p>
                      <div>
                        <a href="tel:+61 423 439 693" class="contact-link">
                          +61 423 439 693
                        </a>
                      </div>
                    </div>
                    <div>
                      <p class="label dark">
                        Clayton Office:<span class="gray-text-color"></span>
                      </p>
                      <div>272 Clayton Road Clayton VIC 3168 (Australia)</div>
                    </div>
                    <div>
                      <p class="label dark">
                        City Office:<span class="gray-text-color"></span>
                      </p>
                      <div>
                        Level 8, 20 Queen Street Melbourne VIC 3000 (Australia)
                      </div>
                    </div>
                  </div>
                </div>
                <div class="divider-line"></div>
                <div class="foorer-list">
                  <div class="footer-title">Find us</div>
                  <div>
                    <div class="social-grid">
                      <a
                        href=""
                        target="_blank"
                        class="social-link-main w-inline-block"
                      >
                        <img
                          src={Instagram}
                          loading="lazy"
                          alt=""
                          class="social-icon"
                        />
                      </a>
                      <a
                        href=""
                        target="_blank"
                        class="social-link-main w-inline-block"
                      >
                        <img
                          src={Youtube}
                          loading="lazy"
                          alt=""
                          class="social-icon no-invert"
                        />
                      </a>
                      <a
                        href=""
                        target="_blank"
                        class="social-link-main w-inline-block"
                      >
                        <img
                          src={LinkedIn}
                          loading="lazy"
                          alt=""
                          class="social-icon"
                        />
                      </a>
                      <a
                        href=""
                        target="_blank"
                        class="social-link-main w-inline-block"
                      >
                        <img
                          src={Facebook}
                          loading="lazy"
                          width="20"
                          alt=""
                          class="social-icon no-invert"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <GetInTouch />
    </>
  );
};

export default ContactUs;
